import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppOwnerGuard implements CanActivate {
    private _authSvc = inject(AuthService);
    private _router = inject(Router);

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Check if the user has the 'app_owner' basic role
        if (this._authSvc.hasBasicRole('app_owner')) {
            return true;
        }

        // Redirect to the selection page
        return this._router.parseUrl('/select/projects');
    }
}
